import { ReactNode } from 'react'

// MUI
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import { Button, ButtonProps, Tooltip } from '@mui/material'
import { useTranslate } from 'react-admin'

interface IButton {
    onClick: () => void
    key: ReactNode | null
    className?: string
    style?: any
    visible?: boolean
    sx?: ButtonProps['sx']
}

const AddButton = ({ onClick, className, sx }: IButton) => {
    return (
        <Button onClick={onClick} aria-label="Add" className={className} sx={sx}>
            <AddIcon />
        </Button>
    )
}

const RemoveButton = ({ onClick, className, sx }: IButton) => {
    const translate = useTranslate()
    return (
        <Tooltip
            arrow
            placement="left"
            title={translate('manager.resources.preset.manager.delete_preset_node')}
        >
            <Button onClick={onClick} aria-label="Remove" className={className} sx={sx}>
                <DeleteIcon />
            </Button>
        </Tooltip>
    )
}

export { AddButton, RemoveButton }
